import { SkuDescriptionProps } from '@/types/props/components/skus';
import { getReleaseDate } from '@/utilites/sku/sku.dates.utils';

const SkuDescription = ({
  skuBottleSizeInMl,
  skuVolumeInPercent,
  skuReleaseDate,
  IncludeVolumeInPercent = true,
}: SkuDescriptionProps) => {
  return (
    <>
      {skuBottleSizeInMl &&
        `${skuBottleSizeInMl / 10}cl ${IncludeVolumeInPercent ? '|' : ''} `}
      {IncludeVolumeInPercent &&
        skuVolumeInPercent &&
        `${skuVolumeInPercent / 10}% `}
      {getReleaseDate(skuReleaseDate)
        ? `| ${getReleaseDate(skuReleaseDate)}`
        : ''}
    </>
  );
};
export default SkuDescription;
